import { render, staticRenderFns } from "./ShareToFacebook.vue?vue&type=template&id=611a1532&"
import script from "./ShareToFacebook.vue?vue&type=script&lang=js&"
export * from "./ShareToFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports